import { createFileRoute } from "@tanstack/react-router";
import { ScheduleLandingPage, scheduleSeoHead } from "@/components/schedule-landing-page";
import { AGENCY_LP_DESCRIPTION, AGENCY_LP_SHARED } from "@/lib/lp-schedule-agency";
import { SITE_URL } from "@/lib/seo-constants";

/**
 * Variant arm (B) of the `/lp/schedule-agency` headline test. Identical to the
 * control in every respect except the H1: the control leads with the revenue
 * opportunity, B leads with the outcome plus a money-back guarantee.
 *
 * Traffic is split at the edge: the control URL runs a 50/50 coin flip and 302s
 * the "b" arm here (see `handleAbSplit` in src/server.ts). Keeping B on its own
 * URL is what lets the PostHog funnel segment by `$pathname` with no extra
 * instrumentation. This page is `noindex` and canonicalizes to the control so
 * the two arms consolidate for search.
 */

const CONTROL_PATH = "/lp/schedule-agency";
const LP_PATH = "/lp/schedule-agency-b";
const LP_TITLE = "Increase AI Mentions & Citations for Your Clients in 90 Days, or Money Back";

const H1 =
  "Use this to increase AI traffic for your clients on autopilot, or get your money back*";

export const Route = createFileRoute("/lp/schedule-agency-b")({
  head: () =>
    scheduleSeoHead({
      path: LP_PATH,
      title: LP_TITLE,
      description: AGENCY_LP_DESCRIPTION,
      noindex: true,
      canonical: `${SITE_URL}${CONTROL_PATH}`,
    }),
  component: LandingPage,
});

function LandingPage() {
  // Override the shared `formName` so leads from this arm carry a distinct Loops
  // source (`schedule-agency-b`) — otherwise both arms upsert as the control
  // and the headline test can't be attributed at the contact level.
  return <ScheduleLandingPage title={H1} {...AGENCY_LP_SHARED} formName="schedule-agency-b" />;
}
